import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectChatStreaming } from "../../../store/selector";
import { ReactComponent as ExportIcon } from "../../../assets/svg/floating-chat-expand.svg";
import { ReactComponent as CollapseIcon } from "../../../assets/svg/floating-chat-collapse.svg";
import { ReactComponent as PlusIcon } from "../../../assets/svg/floating-chat-new.svg";
import { ReactComponent as AIChatBotIcon } from "../../../assets/svg/teammate-ai.svg";

import {
  FloatingChatPanelStyle,
  FloatingChatHeaderStyle,
  FloatingChatHeaderActionsStyle,
  FloatingChatActionIconStyle,
  FloatingChatTitleStyle,
  FloatingIntroPanelStyle
} from "./Styles";
import { Tooltip } from "antd";

const TooltipTitle = ({ text }) => {
  return <div style={{ color: "black", fontFamily: '"Open Sans", sans-serif' }}>{text}</div>;
};

const FloatingChatPanel = ({ isVisible = false, onClose, onExpand, onNewChat, children }) => {
  const { t } = useTranslation();
  const isStreaming = useSelector(selectChatStreaming);

  if (!isVisible) {
    return null;
  }

  const handleExpand = () => {
    if (isStreaming) {
      return;
    }
    onExpand();
  };

  const handleNewChat = () => {
    if (isStreaming) {
      return;
    }
    onNewChat();
  };

  return (
    <FloatingChatPanelStyle>
      <FloatingChatHeaderStyle>
        <FloatingChatTitleStyle>
          <AIChatBotIcon style={{ width: "22px", height: "22px" }} />
          {t("ai_chat_bot.chat_bot_name")}
        </FloatingChatTitleStyle>

        <FloatingChatHeaderActionsStyle>
          <Tooltip
            title={
              <TooltipTitle
                text={t(isStreaming ? "ai_chat_bot.open_chat_pages_streaming" : "ai_chat_bot.open_chat_pages")}
              />
            }
            color="white"
          >
            <FloatingChatActionIconStyle disabled={isStreaming} onClick={handleExpand}>
              <ExportIcon />
            </FloatingChatActionIconStyle>
          </Tooltip>

          <Tooltip title={<TooltipTitle text={t("ai_chat_bot.new_chat")} />} color="white">
            <FloatingChatActionIconStyle disabled={isStreaming} onClick={handleNewChat}>
              <PlusIcon />
            </FloatingChatActionIconStyle>
          </Tooltip>

          <Tooltip title={<TooltipTitle text={t("ai_chat_bot.collapse_chat")} />} color="white">
            <FloatingChatActionIconStyle onClick={onClose}>
              <CollapseIcon />
            </FloatingChatActionIconStyle>
          </Tooltip>
        </FloatingChatHeaderActionsStyle>
      </FloatingChatHeaderStyle>

      <FloatingIntroPanelStyle>{children}</FloatingIntroPanelStyle>
    </FloatingChatPanelStyle>
  );
};

export { FloatingChatPanel };
